"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocalTime = setLocalTime;
const constants_1 = require("@daytrip/constants");
const date_fns_1 = require("date-fns");
const getTimezoneOffsetOrDefault_1 = require("./getTimezoneOffsetOrDefault");
const padDate_1 = require("./padDate");
function setLocalTime(utcDate, timezone, hours, minutes = 0) {
    const rawHourUtc = new Date(`${utcDate.toISOString().slice(0, 11)}${(0, padDate_1.padDate)(hours)}:${(0, padDate_1.padDate)(minutes)}:00Z`);
    const offsetInHours = (0, getTimezoneOffsetOrDefault_1.getTimezoneOffsetOrDefault)(timezone, rawHourUtc) / constants_1.HOUR_IN_MILLISECONDS;
    const dateWithLocalHour = (0, date_fns_1.subHours)(rawHourUtc, offsetInHours);
    return dateWithLocalHour;
}
//# sourceMappingURL=setLocalTime.js.map